import http from '@/shared/http.service';
import { Uris, DefaultConfig } from '@/shared/const';
import { Subject, from, EMPTY } from 'rxjs';
import { ref, onUnmounted, reactive, computed, onMounted } from 'vue';
import { Form, notification } from "ant-design-vue";
import { catchError, switchMap, throttleTime } from 'rxjs/operators';
import dayjs from 'dayjs';
import { useIdentityStore } from '@/stores/useIdentityStore';
import { useRouter } from 'vue-router';


const useForm = Form.useForm;
export default function useBaseConfig() {

    const store = useIdentityStore();
    const router = useRouter();

    const form = reactive({
        id: null, // 分类ID，新增时为null
        title: '',
        isShow: '',
        imageUrl: "",
        linkUrl:"",
        cardImageFiles: [],
    });

    let rules = reactive({
        title: [{ type: 'string', required: true, message: '请输入标题', trigger: 'change' }],

    });

    let { resetFields, validate, validateInfos } = useForm(form, rules);
    //保存
    const saved$ = new Subject();
    const isAdd = ref(true);
    const handleSave = (type) => {
        from(validate()).pipe(
            switchMap(validateResult => {
                form.cardImageFiles = [];

                if (!isAdd.value) {
                    return http.put(Uris.PutBaseConfig, form);
                }
                else
                    return http.post(Uris.PostBaseConfig, form);
            }), catchError((err, caught) => {
                console.log(err);
                return EMPTY;
            })
        ).subscribe(result => {
            notification.success({
                message: '数据已保存',
                description: '',
                duration: 2
            });
            //恢复字段验证规则
            saved$.next(type);
        });
    };

    return {
        isAdd,
        form,
        saved$,
        handleSave,
    };
}